import * as logger from '../../logger';
import * as api from '../../api';

import PharmacyComponent from '../Pharmacy';

import { useBrowserCoordinates } from '../../hooks/common/useBrowserCoordinates';

interface Props {
  value: string;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
  practice?: api.Practice.Practice | null;
}

export function Pharmacy(props: Props) {
  const { value, updateFieldValue, saveFieldValue, practice } = props;
  const browserCoordinates = useBrowserCoordinates();

  let pharmacies: api.Pharmacy.PrevisitPharmacy[] = [];

  if (value) {
    try {
      const parsed = JSON.parse(value);
      pharmacies = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      logger.error(e, `Pharmacy: Failed parsing form field value ${value}`);
    }
  }

  return (
    <PharmacyComponent
      latitude={browserCoordinates?.latitude ?? practice?.latitude}
      longitude={browserCoordinates?.longitude ?? practice?.longitude}
      saveFieldValue={saveFieldValue}
      updateFieldValue={updateFieldValue}
      initialPharmacies={pharmacies}
    />
  );
}
